import { render, staticRenderFns } from "./AddProductOptions.vue?vue&type=template&id=988b5114&scoped=true"
import script from "./AddProductOptions.vue?vue&type=script&lang=js"
export * from "./AddProductOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "988b5114",
  null
  
)

export default component.exports